import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import {HttpRequestErrorHandler} from '@rbaip/ui-component';
import {ItemSummarySiteAuctionEventService} from './item-summary-site-auction-event.service';
import {SiteHoldingPen} from '../domain/auction-event';
import {appConfig} from '../app.config';

@Injectable({
  providedIn: 'root'
})
export class ItemSummarySiteAuctionEventServiceImpl extends ItemSummarySiteAuctionEventService {

  constructor(private http: HttpClient) {
    super();
  }

  public getSiteHoldingPen(siteId: number): void {
    let url = '/api/sites/{siteId}/holding-pen';
    url = url.replace('{siteId}', String(siteId));
    this.http.get(url, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('getSiteHoldingPen', []))
      )
      .subscribe(response => {
        const siteHoldingPen = response as SiteHoldingPen;
        this.siteHoldingPenCallback.next(siteHoldingPen);
      });
  }
}

